<div class="input-group">
  <input type="text" class="form-control" pattern="{{textInputPattern}}"
    [class.is-invalid]="searchFailed"
    [ngbTypeahead]="search"
    [inputFormatter]="formatter"
    [resultFormatter]="formatter"
    [resultTemplate]="rtIotRegister"
    [disabled]="disabled"
    [(ngModel)]="selectedRegister"
    (selectItem)="selectItem($event)"
    (focus)="searchSubject$.next($event.target['value'])"
    (keyup.enter)="searchSubject$.next($event.target.value)"
    placeholder="{{ 'common.placeholders.search.iotRegister' | translate }}" />

    <span class="input-group-text">
      @if (!disabled && (selectedRegister || searchText)) {
        <button class="btn btn-link btn-sm"
          title="{{ 'common.tooltip.erase' | translate }}"
          (click)="clearInput()">
          <fa-icon [icon]="icons.erase"></fa-icon>
        </button>
      }
    </span>

    @if (searchFailed) {
      <div class="invalid-feedback" translate="common.search.message.failed"></div>
    }

    <ng-template #rtIotRegister let-iotRegister="result" let-t="term">
      <ngb-highlight [result]="iotRegister['label' + this.crtLang.toUpperCase()]" [term]="t"></ngb-highlight>
    </ng-template>
  </div>
